import React from 'react';
import RoleSelector from './RoleSelector';

/** Orgs the user belongs to (ticked) that have no role chosen yet. */
export function orgIdsMissingRoles(orgIds, orgRoles) {
  return orgIds.filter((oid) => !(orgRoles[oid] || []).length);
}

/**
 * Organization checklist with a role picker under each ticked organization. A role is required
 * for every ticked organization: a membership with no role grants nothing, so the picker flags
 * it and callers block saving (`orgIdsMissingRoles`).
 */
function OrgRolesPicker({
  organizations,
  catalog,
  orgIds,
  orgRoles,
  onToggleOrg,
  onRolesChange,
  showErrors = true,
  idPrefix = 'org',
  uniform = false,
  renderRoleExtra,
}) {
  return (
    <div className="grid grid-cols-1 gap-2">
      {[...organizations]
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((org) => {
          const oid = String(org.id);
          const checked = orgIds.includes(oid);
          const missing = showErrors && checked && !(orgRoles[oid] || []).length;
          return (
            <div key={oid} className={`rounded border p-2 ${missing ? 'border-red-300' : 'border-hairline'}`}>
              <label className="flex items-center space-x-2">
                <input type="checkbox" checked={checked} onChange={(e) => onToggleOrg(oid, e.target.checked)} />
                <span className="font-medium">{org.name}</span>
              </label>
              {checked ? (
                <div className="mt-2 space-y-2 pl-6">
                  <RoleSelector
                    compact
                    uniform={uniform}
                    catalog={catalog}
                    value={orgRoles[oid] || []}
                    onChange={(roles) => onRolesChange(oid, roles)}
                    idPrefix={`${idPrefix}-${oid}`}
                  >
                    {renderRoleExtra ? renderRoleExtra(org) : null}
                  </RoleSelector>
                  {missing ? <p className="mt-1.5 text-xs text-red-600">Pick at least one role for {org.name}.</p> : null}
                </div>
              ) : null}
            </div>
          );
        })}
    </div>
  );
}

export default OrgRolesPicker;
